import {http} from "../../http";
import {city} from "ca-plateform-organization-domain";
import {buildBonusGroupApiUrl} from "api/configuration";

export interface ExportOrganizationsQueryBase
    extends city.colisactiv.organization.model.features
        .ExportOrganizationsQueryBase {}

export interface OrganizationTypeBase
    extends city.colisactiv.organization.model.OrganizationTypeBase {}

export const exportOrganizations = async (
  organizationTypes: string[]
): Promise<string | null> => {
  const query: ExportOrganizationsQueryBase = {
    type: "EXPORT_ORGANIZATIONS",
    payload: {
      types: organizationTypes.map((type: string) => {
        return {type: type}
      })
    }
  }
  return http.fetchDownloadableFile(
    buildBonusGroupApiUrl(`/organizations/export`),
    "Une erreur est survenue lors de l'export des organisations",
    "post",
    JSON.stringify(query)
  );
};
